import { useEffect, useState } from "react";
import { notify } from "../../common/Toast";
import {
  foundry,
  materialInward,
  rawMaterials,
  SpectroCom,
  inchargeAPI,
} from "../../utlis/apiService";
import { HiMinusCircle } from "react-icons/hi";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import Model from "../../common/Model";
import EntityAddModal from "../../common/EntityAddModal";
import { motion, AnimatePresence } from "framer-motion";
import { IoMdClose } from "react-icons/io";
import { BsSave2, BsSave2Fill } from "react-icons/bs";
import Button from "../../common/Button";
import InputField from "../../common/InputField";
import { IoClose } from "react-icons/io5";
import {
  FaPaperPlane,
  FaFlask,
  FaFire,
  FaBalanceScale,
  FaBoxes,
  FaHistory,
  FaThermometerHalf,
  FaClipboardList,
} from "react-icons/fa";
import {
  MdClose,
  MdOutlineDashboardCustomize,
  MdOutlineSettings,
} from "react-icons/md";
import { HiPlusCircle, HiOutlineIdentification } from "react-icons/hi";
import { RiCalendarEventLine, RiUserSettingsLine } from "react-icons/ri";
import {
  FiDatabase,
  FiTruck,
  FiBox,
  FiClock,
  FiZap,
  FiCpu,
  FiActivity,
  FiBarChart2,
  FiPlus,
  FiMinus,
  FiFileText,
} from "react-icons/fi";

dayjs.extend(duration);
dayjs.extend(utc);

const SectionTitle = ({ title, icon: Icon, className }) => {
  return (
    <div
      className={`flex items-center gap-2 mb-6 border-b border-slate-200 pb-2 ${className}`}
    >
      {Icon && <Icon className="text-primary text-xl" />}
      <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wider">
        {title}
      </h3>
    </div>
  );
};

const fixedSelectComponents = [
  { label: "Mg", value: 1 },
  { label: "Si", value: 2 },
  { label: "Fe", value: 3 },
  { label: "Zn", value: 4 },
  { label: "Cu", value: 5 },
  { label: "Al", value: 6 },
];

const FoundryForm = ({ onCancel, initialData, onSave, isEditing }) => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const today = new Date().toISOString()?.split("T")[0];
  const [isRawMaterialData, setIsRawMaterialData] = useState([]);
  const [isSkuData, setIsSkuData] = useState([]);
  const [isSpectroData, setIsSpectroData] = useState([]);
  const [isInchargeData, setIsInchargeData] = useState([]);
  const [scrapInputs, setScrapInputs] = useState([
    { Inward_No: "", qty: "", casting_No: "" },
  ]);
  const [sampleSpectroInputs, setSampleSpectroInputs] = useState(
    fixedSelectComponents.map((c) => ({
      componentId: c.value,
      label: c.label,
      percentage: "",
      editable: false,
    })),
  );

  const [finalSpectroInputs, setFinalSpectroInputs] = useState(
    fixedSelectComponents.map((c) => ({
      componentId: c.value,
      label: c.label,
      percentage: "",
      editable: false,
    })),
  );

  const [otherMetalEntries, setOtherMetalEntries] = useState([
    {
      CASTING_NO: "",
      INGOT: 0,
      PLANT_SCRAP: 0,
      PLANT_DISCARD: 0,
      DROSS_INGOT: 0,
      BEND_LOG: 0,
      HILL_METAL: 0,
      PIT_METAL: 0,
      TENDIS_METAL: 0,
      DROSS_METAL: 0,
      CREATED_BY: userId,
    },
  ]);
  const [foundryEntry, setFoundryEntry] = useState({
    CASTING_DATE: today,
    IN_CHARGE_ID: "",
    LDO_PRE_HEATING_LEVEL: "",
    LDO_CHARGING_START_LEVEL: "",
    LDO_CATING_TIME_LEVEL: "",
    LDO_MAIN_TANK_OPENING_LEVEL: "",
    LDO_MAIN_TANK_CLOSING_LEVEL: "",
    LDO_TOTAL_CONSUMPTION: "",
    ALLOY_GRAD: "",
    HLINE_GRAD: "",
    NO_OF_LOGS: "",
    LOG_LENGTH: "",
    LOG_WEIGHT: "",
    TOTAL_OUTPUT_WEIGHT: "",
    REMARK: "",
    CREATED_BY: userId,
  });
  const [furnaceEntries, setFurnaceEntries] = useState([
    {
      FURNACE_NO: 1,
      PRE_HEATED: false,
      CHARGING_START_TIME: "",
      CHARGING_END_TIME: "",
      CASTING_START_TIME: "",
      CASTING_END_TIME: "",
      TOTAL_TIME: "",
      CREATED_BY: userId,
    },
  ]);
  const [byProductEntries, setByProductEntries] = useState([
    {
      DROSS: 0,
      ALUMINIUM_METAL_REUSABLE: 0,
      IRON: 0,
      DROSS_INGOT: 0,
      BURNING_LOSS: 0,
      CREATED_BY: userId,
    },
  ]);
  const [chemicalEntries, setChemicalEntries] = useState([
    { MATERIAL_ID: "", QUANTITY: "", CREATED_BY: userId },
  ]);
  const [rawMaterialsResData, setRawMaterialsResData] = useState([]);
  const [scrapTotal, setScrapTotal] = useState(0);
  const [totalInputKg, setTotalInputKg] = useState(0);
  const [modalType, setModalType] = useState(null);

  useEffect(() => {
    if (!initialData) {
      const now = dayjs().format("YYYY-MM-DDTHH:mm");
      setFurnaceEntries((prev) =>
        prev.map((entry) => ({
          ...entry,
          CHARGING_START_TIME: now,
          CASTING_END_TIME: now,
          CASTING_START_TIME: now,
          CHARGING_END_TIME: now,
        })),
      );
    }
  }, []);

  const handleScrapChange = (index, field, value) => {
    const updated = [...scrapInputs];
    updated[index][field] = value;

    if (field === "Inward_No") {
      const selected = isSkuData.find((opt) => opt.value === Number(value));
      updated[index].skuDetail = selected?.detail || "";
    }

    setScrapInputs(updated);

    const newScrapTotal = updated.reduce(
      (sum, scrap) => sum + (parseFloat(scrap.QUANTITY) || 0),
      0,
    );
    setScrapTotal(newScrapTotal);
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [skuRes, rawMaterialsRes, spectroRes, inchargeRes] =
          await Promise.all([
            materialInward.getAllSKU(),
            rawMaterials.getAll(),
            SpectroCom.getAll(),
            inchargeAPI.getAll(),
          ]);

        setIsSkuData(
          skuRes.map((c) => ({
            value: c.inward_No,
            label: c.skU_No,
            detail: c.skU_Detail,
          })),
        );
        setRawMaterialsResData(rawMaterialsRes);
        setIsRawMaterialData(
          rawMaterialsRes.map((c) => ({
            value: Number(c.id),
            label: c.name,
          })),
        );

        setIsSpectroData(
          spectroRes.map((c) => ({
            value: c.components_Id,
            label: c.components_Name,
          })),
        );

        setIsInchargeData(
          inchargeRes.data.map((c) => ({
            value: c.id,
            label: c.incharge_Name,
          })),
        );
      } catch (error) {
        notify("Error fetching dropdown data", "error");
      }
    };
    fetchDropdownData();
  }, []);

  const handleAddScrapInput = () => {
    setScrapInputs([...scrapInputs, { Inward_No: "", qty: "" }]);
  };

  const handleAddChemicalInput = () => {
    setChemicalEntries([
      ...chemicalEntries,
      { materialId: "", qty: "", stock: "" },
    ]);
  };

  const handleAddSampleSpectro = () => {
    setSampleSpectroInputs([
      ...sampleSpectroInputs,
      { componentId: "", percentage: "" },
    ]);
  };

  const handleAddFinalSpectro = () => {
    setFinalSpectroInputs([
      ...finalSpectroInputs,
      { componentId: "", percentage: "" },
    ]);
  };

  const handleRemoveScrapInput = async (indexToRemove) => {
    const item = scrapInputs[indexToRemove];
    if (isEditing && item.SEQ_NO) {
      try {
        await foundry.deleteScrap(foundryEntry.CASTING_NO, item.SEQ_NO);
        notify("Scrap entry deleted", "success");
      } catch (err) {
        notify("Failed to delete scrap entry", "error");
        return;
      }
    }
    setScrapInputs(scrapInputs.filter((_, idx) => idx !== indexToRemove));
  };

  const handleRemoveChemicals = async (indexToRemove) => {
    const item = chemicalEntries[indexToRemove];

    if (isEditing && item.SEQ_NO) {
      try {
        await foundry.deleteChemical(foundryEntry.CASTING_NO, item.SEQ_NO);
        notify("Chemical entry deleted", "success");
      } catch (err) {
        notify("Failed to delete chemical entry", "error");
        return;
      }
    }

    setChemicalEntries(
      chemicalEntries.filter((_, idx) => idx !== indexToRemove),
    );
  };

  const handleRemoveSampleSpectro = async (indexToRemove) => {
    const item = sampleSpectroInputs[indexToRemove];

    if (isEditing && item.SEQ_NO) {
      try {
        await foundry.deleteSampleSpectro(foundryEntry.CASTING_NO, item.SEQ_NO);
        notify("Sample Spectro deleted", "success");
      } catch (err) {
        notify("Failed to delete Sample Spectro", "error");
        return;
      }
    }

    setSampleSpectroInputs(
      sampleSpectroInputs.filter((_, idx) => idx !== indexToRemove),
    );
  };

  const handleRemoveFinalSpectro = async (indexToRemove) => {
    const item = finalSpectroInputs[indexToRemove];

    if (isEditing && item.SEQ_NO) {
      try {
        await foundry.deleteFinalSpectro(foundryEntry.CASTING_NO, item.SEQ_NO);
        notify("Final Spectro deleted", "success");
      } catch (err) {
        notify("Failed to delete Final Spectro", "error");
        return;
      }
    }

    setFinalSpectroInputs(
      finalSpectroInputs.filter((_, idx) => idx !== indexToRemove),
    );
  };

  const handleFurnaceChange = (index, field, value) => {
    const updated = [...furnaceEntries];
    updated[index][field] = value;

    const { CHARGING_START_TIME, CASTING_END_TIME } = updated[index];
    if (CHARGING_START_TIME && CASTING_END_TIME) {
      const start = dayjs(CHARGING_START_TIME);
      const end = dayjs(CASTING_END_TIME);

      if (end.isBefore(start)) {
        updated[index].TOTAL_TIME = null;
      } else {
        const duration = dayjs.duration(end.diff(start));
        const totalHours = duration.asHours();
        const hours = Math.floor(totalHours);
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        updated[index].TOTAL_TIME = `${String(hours).padStart(2, "0")}:${String(
          minutes,
        ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
      }
    } else {
      updated[index].TOTAL_TIME = null;
    }

    setFurnaceEntries(updated);
  };

  const totalOtherMetalsKg = otherMetalEntries.reduce((sum, item) => {
    return (
      sum +
      Number(item.INGOT || 0) +
      Number(item.PLANT_SCRAP || 0) +
      Number(item.PLANT_DISCARD || 0) +
      Number(item.DROSS_INGOT || 0) +
      Number(item.BEND_LOG || 0) +
      Number(item.HILL_METAL || 0) +
      Number(item.PIT_METAL || 0) +
      Number(item.TENDIS_METAL || 0) +
      Number(item.DROSS_METAL || 0)
    );
  }, 0);

  const handleOtherMetalChange = (index, field, value) => {
    const updated = [...otherMetalEntries];
    updated[index][field] = value;

    const calcWeight = (item) =>
      Number(item.INGOT || 0) +
      Number(item.PLANT_SCRAP || 0) +
      Number(item.PLANT_DISCARD || 0) +
      Number(item.DROSS_INGOT || 0) +
      Number(item.BEND_LOG || 0) +
      Number(item.HILL_METAL || 0) +
      Number(item.PIT_METAL || 0) +
      Number(item.TENDIS_METAL || 0) +
      Number(item.DROSS_METAL || 0);

    updated[index].TOTAL_WEIGHT = calcWeight(updated[index]);

    setOtherMetalEntries(updated);

    const allMetalsSum = updated.reduce(
      (sum, item) => sum + (item.TOTAL_WEIGHT || 0),
      0,
    );
    setTotalInputKg(scrapTotal + allMetalsSum);
  };

  useEffect(() => {
    const metalsSum = otherMetalEntries.reduce((sum, item) => {
      return (
        sum +
        Number(item.INGOT || 0) +
        Number(item.PLANT_SCRAP || 0) +
        Number(item.PLANT_DISCARD || 0) +
        Number(item.DROSS_INGOT || 0) +
        Number(item.BEND_LOG || 0) +
        Number(item.HILL_METAL || 0) +
        Number(item.PIT_METAL || 0) +
        Number(item.TENDIS_METAL || 0) +
        Number(item.DROSS_METAL || 0)
      );
    }, 0);

    setTotalInputKg(scrapTotal + metalsSum);
  }, [scrapTotal, otherMetalEntries]);

  useEffect(() => {
    if (initialData) {
      setFoundryEntry(initialData.foundryEntry || {});
      setScrapInputs(initialData.scrapEntries || []);
      setScrapTotal(initialData.scrapTotal || 0);
      setOtherMetalEntries(initialData.otherMetalEntries || []);
      setFurnaceEntries(initialData.furnaceEntries || []);
      setByProductEntries(initialData.byProductEntries || []);
      setChemicalEntries(initialData.chemicalEntries || []);
      setFinalSpectroInputs(initialData.finalSpectroEntries || []);
      setSampleSpectroInputs(initialData.sampleSpectroEntries || []);
    }
  }, [initialData]);

  useEffect(() => {
    const logLength = Number(foundryEntry.LOG_LENGTH || 0);
    const logCount = Number(foundryEntry.NO_OF_LOGS || 0);
    const singleWeight = logLength * 0.034;
    const totalWeight = singleWeight * logCount;

    setFoundryEntry((prev) => ({
      ...prev,
      LOG_WEIGHT: parseFloat(singleWeight.toFixed(2)),
      TOTAL_OUTPUT_WEIGHT: parseFloat(totalWeight.toFixed(2)),
    }));
  }, [foundryEntry.LOG_LENGTH, foundryEntry.NO_OF_LOGS]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // const isValid = validateForm();
    // if (!isValid) return;

    const payload = {
      foundryEntry: {
        ...foundryEntry,
        IN_CHARGE_ID: Number(foundryEntry.IN_CHARGE_ID),
        LDO_PRE_HEATING_LEVEL: Number(foundryEntry.LDO_PRE_HEATING_LEVEL),
        LDO_CHARGING_START_LEVEL: Number(foundryEntry.LDO_CHARGING_START_LEVEL),
        LDO_CATING_TIME_LEVEL: Number(foundryEntry.LDO_CATING_TIME_LEVEL),
        LDO_MAIN_TANK_OPENING_LEVEL: Number(
          foundryEntry.LDO_MAIN_TANK_OPENING_LEVEL,
        ),
        LDO_MAIN_TANK_CLOSING_LEVEL: Number(
          foundryEntry.LDO_MAIN_TANK_CLOSING_LEVEL,
        ),
        LDO_TOTAL_CONSUMPTION: Number(foundryEntry.LDO_TOTAL_CONSUMPTION),
        NO_OF_LOGS: Number(foundryEntry.NO_OF_LOGS),
        LOG_LENGTH: Number(foundryEntry.LOG_LENGTH),
        LOG_WEIGHT: Number(foundryEntry.LOG_WEIGHT),
        TOTAL_OUTPUT_WEIGHT: Number(foundryEntry.TOTAL_OUTPUT_WEIGHT),
        CREATED_BY: userId,
      },
      scrapEntries: scrapInputs.map((item, index) => ({
        SEQ_NO: index + 1,
        CASTING_NO: isEditing ? initialData?.CASTING_NO || "" : "",
        INWARD_NO: Number(item.Inward_No),
        QUANTITY: Number(item.QUANTITY),
        CREATED_BY: userId,
      })),
      otherMetalEntries: otherMetalEntries.map((item) => ({
        ...item,
        INGOT: Number(item.INGOT),
        PLANT_SCRAP: Number(item.PLANT_SCRAP),
        PLANT_DISCARD: Number(item.PLANT_DISCARD),
        DROSS_INGOT: Number(item.DROSS_INGOT),
        BEND_LOG: Number(item.BEND_LOG),
        HILL_METAL: Number(item.HILL_METAL),
        PIT_METAL: Number(item.PIT_METAL),
        TENDIS_METAL: Number(item.TENDIS_METAL),
        DROSS_METAL: Number(item.DROSS_METAL),
        TOTAL_WEIGHT: Number(totalOtherMetalsKg),
        CREATED_BY: userId,
      })),
      furnaceEntries: furnaceEntries.map((item) => ({
        FURNACE_NO: Number(item.FURNACE_NO),
        PRE_HEATED: Boolean(item.PRE_HEATED),
        CHARGING_START_TIME: item.CHARGING_START_TIME,
        CHARGING_END_TIME: item.CHARGING_END_TIME,
        CASTING_START_TIME: item.CASTING_START_TIME,
        CASTING_END_TIME: item.CASTING_END_TIME,
        TOTAL_TIME: item.TOTAL_TIME,
        CREATED_BY: userId,
      })),
      byProductEntries: byProductEntries.map((item) => ({
        ...item,
        DROSS: Number(item.DROSS),
        ALUMINIUM_METAL_REUSABLE: Number(item.ALUMINIUM_METAL_REUSABLE),
        IRON: Number(item.IRON),
        DROSS_INGOT: Number(item.DROSS_INGOT),
        BURNING_LOSS: Number(item.BURNING_LOSS),
        CREATED_BY: userId,
      })),
      chemicalEntries: chemicalEntries.map((item, index) => ({
        SEQ_NO: index + 1,
        MATERIAL_ID: Number(item.MATERIAL_ID),
        QUANTITY: Number(item.qty),
        CREATED_BY: userId,
      })),
      finalSpectroEntries: finalSpectroInputs.map((item, index) => ({
        Seq_No: index + 1,
        Components_Id: Number(item.componentId),
        Components_Value: Number(item.percentage),
        CREATED_BY: userId,
      })),
      sampleSpectroEntries: sampleSpectroInputs.map((item, index) => ({
        Seq_No: index + 1,
        Components_Id: Number(item.componentId),
        Components_Value: Number(item.percentage),
        CREATED_BY: userId,
      })),
    };

    onSave(payload, isEditing ? initialData?.CASTING_NO : "");
  };

  const optionMap = {
    rawMaterial: {
      setter: setIsRawMaterialData,
      field: "id",
    },
    sampleSpectroComponent: {
      setter: setIsSpectroData,
      field: "components_Id",
    },
    finalSpectroComponent: {
      setter: setIsSpectroData,
      field: "components_Id",
    },
  };

  const handleEntityAddSuccess = async (type) => {
    const { setter } = optionMap[type];

    try {
      let updatedData;

      switch (type) {
        case "rawMaterial":
          updatedData = await rawMaterials.getAll();
          setter(
            updatedData.map((c) => ({
              value: c.id,
              label: c.name,
            })),
          );
          break;
        case "sampleSpectroComponent":
          updatedData = await SpectroCom.getAll();
          setter(
            updatedData.map((s) => ({
              value: s.components_Id,
              label: s.components_Name,
            })),
          );
          break;
        case "finalSpectroComponent":
          updatedData = await SpectroCom.getAll();
          setter(
            updatedData.map((s) => ({
              value: s.components_Id,
              label: s.components_Name,
            })),
          );
          break;
        default:
          return;
      }

      setModalType(null);
    } catch (err) {
      notify("Failed to refresh dropdown", "error");
    }
  };

  const tabs = [
    { label: "Scrap Inputs", icon: FiDatabase },
    { label: "LDO Table", icon: FiTruck },
    { label: "Other Metals", icon: FiBox },
    { label: "Furnace Time", icon: FiClock },
    { label: "Consumables", icon: FiZap },
    { label: "By-Products", icon: FiCpu },
    { label: "Log Output", icon: FiActivity },
    { label: "Spectro Analysis", icon: FiBarChart2 },
  ];

  const [activeTab, setActiveTab] = useState(0);

  const containerVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3, staggerChildren: 0.1 },
    },
    exit: { opacity: 0, y: -10, transition: { duration: 0.2 } },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: { opacity: 1, x: 0 },
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 z-[9999]">
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl max-h-[92vh] overflow-hidden flex flex-col"
        >
          <div className="bg-gradient-to-r from-primary to-blue-700 text-white px-6 py-4 flex justify-between items-center shadow-lg">
            <div className="flex items-center gap-3">
              <div className="bg-blue-500 p-2 rounded-lg">
                <MdOutlineSettings className="text-white text-xl animate-spin-slow" />
              </div>
              <h2 className="text-xl font-bold text-white tracking-wide">
                {isEditing ? "Edit Foundry Log" : "New Foundry Log"}
              </h2>
            </div>
            <button
              onClick={onCancel}
              className="hover:bg-white/20 p-2 rounded-full transition-colors"
            >
              <MdClose size={28} />
            </button>
          </div>
          <div className="flex flex-col lg:flex-row flex-1 overflow-hidden">
            {/* Sidebar Navigation */}
            <div className="w-full lg:w-72 bg-slate-50 border-r border-slate-200 overflow-y-auto custom-scrollbar p-6">
              <div className="space-y-2">
                {tabs.map((tab, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveTab(idx)}
                    className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-2xl text-sm font-semibold transition-all duration-300 group relative overflow-hidden ${
                      activeTab === idx
                        ? "bg-primary text-white shadow-lg shadow-primary/25"
                        : "text-slate-600 hover:bg-white hover:text-primary hover:shadow-md"
                    }`}
                  >
                    <tab.icon
                      className={`text-lg transition-transform duration-300 ${activeTab === idx ? "scale-110" : "group-hover:scale-110"}`}
                    />
                    <span className="relative z-10">{tab.label}</span>
                    {activeTab === idx && (
                      <motion.div
                        layoutId="activeTabGlow"
                        className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent pointer-events-none"
                      />
                    )}
                  </button>
                ))}
              </div>

              {/* Quick Info Box */}
              <div className="mt-8 p-5 bg-gradient-to-br from-slate-800 to-slate-900 rounded-3xl text-white shadow-xl shadow-slate-200">
                <h4 className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 mb-3">
                  System Summary
                </h4>
                <div className="space-y-4">
                  <div className="flex justify-between items-center bg-white/5 p-3 rounded-2xl border border-white/5">
                    <div className="flex items-center gap-2">
                      <FiDatabase className="text-sky-400" />
                      <span className="text-xs font-medium">Scrap Total</span>
                    </div>
                    <span className="text-xs font-bold">
                      {scrapTotal.toFixed(1)} Kg
                    </span>
                  </div>
                  <div className="flex justify-between items-center bg-white/5 p-3 rounded-2xl border border-white/5">
                    <div className="flex items-center gap-2">
                      <FiActivity className="text-emerald-400" />
                      <span className="text-xs font-medium">Log Pieces</span>
                    </div>
                    <span className="text-xs font-bold">
                      {foundryEntry.NO_OF_LOGS || 0}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-1 overflow-hidden flex flex-col bg-white">
              <div className="px-8 py-4 bg-white border-b border-slate-100 flex flex-wrap gap-8 items-center">
                <div className="flex items-center gap-3 group">
                  <div className="w-10 h-10 rounded-xl bg-sky-50 flex items-center justify-center text-primary border border-sky-100 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                    <RiCalendarEventLine className="text-lg" />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[10px] font-black uppercase tracking-wider text-slate-400">
                      Date
                    </span>
                    <input
                      type="date"
                      className="text-sm font-bold text-slate-800 focus:outline-none bg-transparent"
                      value={foundryEntry.CASTING_DATE}
                      onChange={(e) =>
                        setFoundryEntry({
                          ...foundryEntry,
                          CASTING_DATE: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-orange-50 flex items-center justify-center text-orange-600 border border-orange-100">
                    <HiOutlineIdentification className="text-xl" />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[10px] font-black uppercase tracking-wider text-slate-400">
                      Casting No
                    </span>
                    <span className="text-sm font-bold text-slate-800">
                      {foundryEntry.CASTING_NO || "Pending"}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-3 flex-1 min-w-[200px]">
                  <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600 border border-emerald-100">
                    <RiUserSettingsLine className="text-xl" />
                  </div>
                  <div className="flex flex-col flex-1 pt-1">
                    <InputField
                      type="select"
                      label="Person In-Charge"
                      placeholder="Select Person"
                      value={foundryEntry.IN_CHARGE_ID}
                      onChange={(val) =>
                        setFoundryEntry({ ...foundryEntry, IN_CHARGE_ID: val })
                      }
                      options={isInchargeData}
                      required
                    />
                  </div>
                </div>
              </div>

              <form
                onSubmit={handleSubmit}
                className="flex-1 overflow-y-auto p-8 custom-scrollbar bg-slate-50/30"
              >
                <div className="max-w-4xl mx-auto">
                  <div className="space-y-8">
                    {activeTab === 0 && (
                      <div className="space-y-4">
                        <SectionTitle
                          title="Scrap Inputs Analysis"
                          icon={FiDatabase}
                        />
                        <div className="space-y-4">
                          {scrapInputs.map((scrap, index) => (
                            <motion.div
                              key={index}
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ delay: index * 0.1 }}
                              className="bg-white p-6 rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 group relative overflow-hidden"
                            >
                              <div className="absolute top-0 right-0 w-32 h-32 bg-sky-50/50 rounded-full -mr-16 -mt-16 group-hover:bg-primary/5 transition-colors" />
                              <div className="absolute top-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity z-20">
                                <button
                                  type="button"
                                  onClick={() => handleRemoveScrapInput(index)}
                                  className="w-8 h-8 bg-red-50 text-red-500 rounded-full flex items-center justify-center hover:bg-red-500 hover:text-white transition-all shadow-sm"
                                >
                                  <FiMinus />
                                </button>
                              </div>
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative z-10">
                                <InputField
                                  type="select"
                                  label={`SKU for Scrap ${index + 1}`}
                                  value={scrap.Inward_No}
                                  onChange={(val) =>
                                    handleScrapChange(index, "Inward_No", val)
                                  }
                                  options={isSkuData}
                                  required
                                />
                                <InputField
                                  label="Quantity Used"
                                  type="text"
                                  value={scrap.QUANTITY}
                                  onChange={(val) =>
                                    handleScrapChange(index, "QUANTITY", val)
                                  }
                                  unit="Kg"
                                  placeholder="0.00"
                                  required
                                />
                              </div>
                              <div className="mt-4 flex justify-between items-center relative z-10">
                                {scrap.skuDetail ? (
                                  <div className="flex items-center gap-2 px-3 py-1.5 bg-slate-50 text-slate-500 rounded-xl text-[11px] font-medium border border-slate-100">
                                    <FiFileText className="text-primary" />
                                    {scrap.skuDetail}
                                  </div>
                                ) : (
                                  <div />
                                )}
                              </div>
                            </motion.div>
                          ))}
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
                            <button
                              type="button"
                              onClick={handleAddScrapInput}
                              className="flex items-center justify-center gap-2 py-4 bg-white border-2 border-dashed border-slate-200 text-slate-400 rounded-3xl hover:border-primary hover:text-primary transition-all duration-300 font-bold group"
                            >
                              <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all">
                                <FiPlus />
                              </div>
                              Add Another Scrap Item
                            </button>
                            <div className="bg-gradient-to-br from-primary to-[#2b3a67] p-6 rounded-3xl text-white shadow-xl shadow-primary/20 flex justify-between items-center">
                              <div className="flex flex-col">
                                <span className="text-[10px] font-black uppercase tracking-widest text-white/60">
                                  Total Scrap Load
                                </span>
                                <span className="text-2xl font-black">
                                  {scrapTotal.toFixed(2)}{" "}
                                  <span className="text-sm font-medium opacity-60">
                                    Kg
                                  </span>
                                </span>
                              </div>
                              <FiDatabase
                                size={40}
                                className="opacity-20 translate-x-3"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {activeTab === 1 && (
                      <div className="space-y-6">
                        <SectionTitle
                          title="LDO Consumption Monitoring"
                          icon={FiTruck}
                        />
                        <div className="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-xl relative overflow-hidden">
                          <div className="absolute top-0 right-0 w-48 h-48 bg-orange-50 rounded-full -mr-24 -mt-24 blur-2xl opacity-50" />

                          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10">
                            {[
                              {
                                label: "Pre Heating Level",
                                key: "LDO_PRE_HEATING_LEVEL",
                                unit: "Inches",
                              },
                              {
                                label: "Charging Start Level",
                                key: "LDO_CHARGING_START_LEVEL",
                                unit: "Inches",
                              },
                              {
                                label: "Casting Time Level",
                                key: "LDO_CATING_TIME_LEVEL",
                                unit: "Inches",
                              },
                              {
                                label: "Main Tank Opening",
                                key: "LDO_MAIN_TANK_OPENING_LEVEL",
                                unit: "Inches",
                              },
                              {
                                label: "Main Tank Closing",
                                key: "LDO_MAIN_TANK_CLOSING_LEVEL",
                                unit: "Inches",
                              },
                            ].map((field) => (
                              <InputField
                                key={field.key}
                                label={field.label}
                                unit={field.unit}
                                value={foundryEntry[field.key]}
                                onChange={(val) =>
                                  setFoundryEntry({
                                    ...foundryEntry,
                                    [field.key]: val,
                                  })
                                }
                              />
                            ))}

                            <div className="bg-orange p-2 rounded-xl text-white shadow-lg shadow-orange">
                              <span className="text-[10px] text-black font-semibold uppercase tracking-wider">
                                Calculated Consumption
                              </span>
                              <div className="flex items-center justify-between mt-2 gap-2">
                                <input
                                  type="text"
                                  placeholder="0"
                                  className="text-md text-black bg-transparent border-none outline-none w-full"
                                  value={foundryEntry.LDO_TOTAL_CONSUMPTION}
                                  onChange={(e) =>
                                    setFoundryEntry({
                                      ...foundryEntry,
                                      LDO_TOTAL_CONSUMPTION: e.target.value,
                                    })
                                  }
                                />
                                <span className="text-xs font-bold bg-black/5 px-2 py-1 rounded-lg italic text-black shrink-0">
                                  Liters
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {activeTab === 2 && (
                      <div className="space-y-6">
                        <SectionTitle
                          title="Alternative Metal Sources"
                          icon={FiBox}
                        />
                        <div className="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-xl">
                          {otherMetalEntries.map((item, index) => (
                            <div
                              key={index}
                              className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-6"
                            >
                              {[
                                { label: "Standard Ingot", key: "INGOT" },
                                { label: "Plant Scrap", key: "PLANT_SCRAP" },
                                {
                                  label: "Plant Discard",
                                  key: "PLANT_DISCARD",
                                },
                                { label: "Dross Ingot", key: "DROSS_INGOT" },
                                { label: "Bend Log", key: "BEND_LOG" },
                                { label: "Hill Metal", key: "HILL_METAL" },
                                { label: "Pit Metal", key: "PIT_METAL" },
                                { label: "Tendis Metal", key: "TENDIS_METAL" },
                                { label: "Dross Metal", key: "DROSS_METAL" },
                              ].map((f) => (
                                <InputField
                                  key={f.key}
                                  label={f.label}
                                  unit="Kg"
                                  value={item[f.key]}
                                  onChange={(val) =>
                                    handleOtherMetalChange(index, f.key, val)
                                  }
                                />
                              ))}
                            </div>
                          ))}

                          <div className="mt-12 p-8 bg-slate-900 rounded-3xl flex justify-between items-center text-white relative overflow-hidden">
                            <div className="absolute right-0 bottom-0 w-48 h-48 bg-primary/10 rounded-full blur-3xl" />
                            <div className="relative z-10">
                              <p className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-500 mb-1">
                                Total Resource Load
                              </p>
                              <h3 className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-emerald-400">
                                {totalInputKg.toFixed(2)}{" "}
                                <span className="text-lg font-medium text-slate-400">
                                  Kg
                                </span>
                              </h3>
                            </div>
                            <div className="relative z-10 text-right">
                              <span className="inline-block px-4 py-2 bg-white/5 border border-white/10 rounded-2xl text-[10px] font-bold uppercase tracking-widest text-slate-300">
                                Scrap + Secondary Metals
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {activeTab === 3 && (
                      <div className="space-y-6">
                        <SectionTitle
                          title="Furnace Cycle Logistics"
                          icon={FiClock}
                        />
                        <div className="space-y-6">
                          {furnaceEntries.map((entry, index) => (
                            <div
                              key={index}
                              className="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-xl relative overflow-hidden group"
                            >
                              <div className="absolute top-0 left-0 w-2 h-full bg-primary" />

                              <div className="flex flex-wrap items-center justify-between mb-8 gap-4">
                                <div className="flex items-center gap-4">
                                  <div className="w-12 h-12 rounded-2xl bg-slate-900 text-white flex items-center justify-center font-black">
                                    #{entry.FURNACE_NO}
                                  </div>
                                  <h4 className="text-lg font-black text-slate-800 uppercase tracking-wider">
                                    Furnace Unit Operations
                                  </h4>
                                </div>
                                <label className="flex items-center gap-3 px-6 py-3 bg-slate-50 border border-slate-100 rounded-2xl cursor-pointer hover:bg-white hover:border-primary transition-all shadow-sm">
                                  <input
                                    type="checkbox"
                                    className="w-5 h-5 accent-primary rounded-lg"
                                    checked={entry.PRE_HEATED || false}
                                    onChange={(e) =>
                                      handleFurnaceChange(
                                        index,
                                        "PRE_HEATED",
                                        e.target.checked,
                                      )
                                    }
                                  />
                                  <span className="text-xs font-black uppercase text-slate-600">
                                    Furnace Pre-heated?
                                  </span>
                                </label>
                              </div>

                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                                {[
                                  {
                                    label: "Fur- Charging Start",
                                    key: "CHARGING_START_TIME",
                                  },
                                  {
                                    label: "Fur- Charging End",
                                    key: "CHARGING_END_TIME",
                                  },
                                  {
                                    label: "Casting Start",
                                    key: "CASTING_START_TIME",
                                  },
                                  {
                                    label: "Casting End",
                                    key: "CASTING_END_TIME",
                                  },
                                ].map((t) => (
                                  <InputField
                                    key={t.key}
                                    label={t.label}
                                    type="datetime-local"
                                    value={entry[t.key]}
                                    onChange={(val) =>
                                      handleFurnaceChange(index, t.key, val)
                                    }
                                  />
                                ))}
                              </div>

                              <div className="mt-8 pt-8 border-t border-slate-100 flex justify-end">
                                <div className="flex items-center gap-6">
                                  <div className="text-right">
                                    <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">
                                      Total Time to Produce
                                    </p>
                                    <p className="text-2xl font-black text-primary">
                                      {entry.TOTAL_TIME || "00:00:00"}
                                    </p>
                                  </div>
                                  <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center text-primary border border-primary/10">
                                    <FiClock className="text-2xl animate-pulse" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {activeTab === 4 && (
                      <div className="space-y-6">
                        <SectionTitle
                          title="Chemical Consumables"
                          icon={FiZap}
                        />
                        <div className="space-y-4">
                          {chemicalEntries.map((item, index) => (
                            <motion.div
                              key={index}
                              className="bg-white p-8 rounded-[2.5rem] border border-slate-100 shadow-xl relative group overflow-hidden"
                            >
                              <div className="absolute top-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity">
                                <button
                                  type="button"
                                  onClick={() => handleRemoveChemicals(index)}
                                  className="w-8 h-8 bg-red-50 text-red-500 rounded-full flex items-center justify-center hover:bg-red-500 hover:text-white transition-all shadow-sm"
                                >
                                  <FiMinus />
                                </button>
                              </div>

                              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-end">
                                <InputField
                                  type="selectWithAdd"
                                  label="Raw Material"
                                  value={item.MATERIAL_ID}
                                  onChange={(selected) => {
                                    const selectedMaterial =
                                      rawMaterialsResData.find(
                                        (rm) => rm.id === selected?.value,
                                      );
                                    const updated = [...chemicalEntries];
                                    updated[index].MATERIAL_ID =
                                      selected?.value;
                                    updated[index].stock =
                                      selectedMaterial?.totalQuantity || 0;
                                    setChemicalEntries(updated);
                                  }}
                                  options={isRawMaterialData}
                                  onAddNewClick={() =>
                                    setModalType("rawMaterial")
                                  }
                                  placeholder="Raw Material"
                                />
                                <InputField
                                  label="Quantity Used"
                                  type="text"
                                  value={item.qty}
                                  onChange={(val) => {
                                    const updated = [...chemicalEntries];
                                    updated[index].qty = val;
                                    const selectedMaterial =
                                      rawMaterialsResData.find(
                                        (rm) =>
                                          rm.id ===
                                          Number(updated[index].MATERIAL_ID),
                                      );
                                    const originalStock =
                                      selectedMaterial?.totalQuantity || 0;
                                    updated[index].stock = Math.max(
                                      originalStock - Number(val || 0),
                                      0,
                                    );
                                    setChemicalEntries(updated);
                                  }}
                                  unit="Kg"
                                />
                                <div className="p-4 bg-emerald-50 border border-emerald-100 rounded-2xl">
                                  <p className="text-[10px] font-black uppercase tracking-widest text-emerald-600 mb-1">
                                    Available Stock
                                  </p>
                                  <p className="text-xl font-black text-emerald-800">
                                    {item.stock || "0"}{" "}
                                    <span className="text-xs font-medium opacity-50">
                                      Kg
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </motion.div>
                          ))}

                          <button
                            type="button"
                            onClick={handleAddChemicalInput}
                            className="w-full py-5 bg-white border-2 border-dashed border-slate-200 text-slate-400 rounded-[2.5rem] hover:border-primary hover:text-primary transition-all duration-300 font-bold flex items-center justify-center gap-3 uppercase text-[11px] tracking-widest"
                          >
                            <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center border border-slate-100 group-hover:bg-primary/10">
                              <FiPlus />
                            </div>
                            Register Chemical Component
                          </button>
                        </div>
                      </div>
                    )}

                    {activeTab === 5 && (
                      <div className="space-y-6">
                        <SectionTitle
                          title="By-Product Recovery"
                          icon={FiCpu}
                        />
                        <div className="bg-white p-10 rounded-[2.5rem] border border-slate-100 shadow-xl relative overflow-hidden">
                          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-50 rounded-full blur-3xl opacity-30 -mr-32 -mt-16" />

                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative z-10">
                            {[
                              {
                                label: "Dross",
                                key: "DROSS",
                                icon: FaBalanceScale,
                              },
                              {
                                label: "Aluminum Metal (Reusable)",
                                key: "ALUMINIUM_METAL_REUSABLE",
                                icon: FaBoxes,
                              },
                              {
                                label: "Iron",
                                key: "IRON",
                                icon: FiBox,
                              },
                              {
                                label: "Dross Ingot",
                                key: "DROSS_INGOT",
                                icon: FaBalanceScale,
                              },
                              {
                                label: "Burning Loss",
                                key: "BURNING_LOSS",
                                icon: FaFire,
                              },
                            ].map((f) => (
                              <div
                                key={f.key}
                                className="p-4 bg-slate-50/50 rounded-3xl border border-slate-100 hover:bg-white hover:border-emerald-200 transition-all shadow-sm"
                              >
                                <InputField
                                  label={f.label}
                                  unit="Kg"
                                  value={byProductEntries[0][f.key]}
                                  onChange={(val) =>
                                    setByProductEntries((prev) => {
                                      const updated = [...prev];
                                      updated[0][f.key] = val;
                                      return updated;
                                    })
                                  }
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                    {activeTab === 6 && (
                      <div className="space-y-6">
                        <SectionTitle
                          title="Log Production Output"
                          icon={FiActivity}
                        />
                        <div className="bg-white p-10 rounded-[2.5rem] border border-slate-100 shadow-xl relative overflow-hidden group">
                          <div className="absolute top-0 right-0 w-full h-1 bg-gradient-to-r from-sky-400 to-emerald-400" />

                          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 items-start">
                            <div className="space-y-8 lg:col-span-2">
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <InputField
                                  label="No of Logs Output"
                                  unit="Pieces"
                                  value={foundryEntry.NO_OF_LOGS}
                                  onChange={(val) =>
                                    setFoundryEntry((prev) => ({
                                      ...prev,
                                      NO_OF_LOGS: val,
                                    }))
                                  }
                                />
                                <InputField
                                  label="Length of Log"
                                  unit="mm"
                                  value={foundryEntry.LOG_LENGTH}
                                  onChange={(val) =>
                                    setByProductEntries((prev) => {
                                      setFoundryEntry((p) => ({
                                        ...p,
                                        LOG_LENGTH: val,
                                      }));
                                      return prev;
                                    })
                                  }
                                />
                              </div>

                              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <div className="p-6 bg-slate-50 border border-slate-100 rounded-3xl">
                                  <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">
                                    One Log Weight (L*0.034)
                                  </span>
                                  <p className="text-xl font-black text-slate-800 mt-1">
                                    {(foundryEntry.LOG_LENGTH * 0.034).toFixed(
                                      2,
                                    )}{" "}
                                    <span className="text-xs font-medium opacity-50 italic">
                                      Kg
                                    </span>
                                  </p>
                                </div>
                                <div className="p-6 bg-primary text-white rounded-3xl shadow-xl shadow-primary/20">
                                  <span className="text-[10px] font-black uppercase tracking-widest opacity-60">
                                    Total Output Wt (Formula L*N*0.034)
                                  </span>
                                  <p className="text-3xl font-black mt-1">
                                    {(
                                      foundryEntry.NO_OF_LOGS *
                                      foundryEntry.LOG_LENGTH *
                                      0.034
                                    ).toFixed(2)}{" "}
                                    <span className="text-sm font-medium opacity-60 italic">
                                      Kg
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="bg-slate-900 rounded-[2rem] p-8 text-white h-full flex flex-col justify-between shadow-2xl">
                              <div>
                                <h5 className="text-xs font-black uppercase tracking-widest text-primary mb-4">
                                  Production Ratio
                                </h5>
                                <div className="space-y-4">
                                  <div className="flex justify-between items-end">
                                    <span className="text-xs text-slate-400">
                                      Yield Efficiency
                                    </span>
                                    <span className="text-xl font-bold">
                                      94.2%
                                    </span>
                                  </div>
                                  <div className="w-full h-1.5 bg-white/10 rounded-full overflow-hidden">
                                    <motion.div
                                      initial={{ width: 0 }}
                                      animate={{ width: "94%" }}
                                      className="h-full bg-primary"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="mt-8">
                                <p className="text-[10px] leading-relaxed text-slate-500 font-medium">
                                  Calculated based on standard L*N*0.034
                                  manufacturing formula for extrusion log
                                  processing.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {activeTab === 7 && (
                      <div className="space-y-8">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-8  rounded-[2.5rem] text-white shadow-2xl relative overflow-hidden">
                          <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full -mr-32 -mt-32 blur-3xl" />

                          <div className="relative z-10">
                            <InputField
                              label="Alloy Grade"
                              type="text"
                              placeholder="Enter Alloy Grade"
                              value={foundryEntry.ALLOY_GRAD}
                              bgColor="bg-white/5 border-gray text-black"
                              onChange={(val) =>
                                setFoundryEntry((prev) => ({
                                  ...prev,
                                  ALLOY_GRAD: val,
                                }))
                              }
                              required
                            />
                          </div>
                          <div className="relative z-10">
                            <InputField
                              label="H-Line Grade"
                              type="text"
                              placeholder="Enter H-Line Grade"
                              value={foundryEntry.HLINE_GRAD}
                              bgColor="bg-white/5 border-gray text-black"
                              onChange={(val) =>
                                setFoundryEntry((prev) => ({
                                  ...prev,
                                  HLINE_GRAD: val,
                                }))
                              }
                              required
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                          <div className="bg-white p-6 rounded-[2rem] border border-slate-100 shadow-xl shadow-slate-200/50">
                            <div className="flex items-center gap-3 mb-6">
                              <div className="w-10 h-10 rounded-xl bg-violet-50 flex items-center justify-center text-violet-600 border border-violet-100 uppercase text-[10px] font-black tracking-widest">
                                <FaFlask />
                              </div>
                              <h4 className="text-sm font-black text-slate-800 uppercase tracking-widest">
                                Sample Spectro Report Component (%)
                              </h4>
                            </div>

                            <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
                              {sampleSpectroInputs.map((item, index) => (
                                <div
                                  key={index}
                                  className="group p-4 bg-slate-50 border border-slate-100 rounded-2xl relative hover:bg-white hover:shadow-lg transition-all"
                                >
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleRemoveSampleSpectro(index)
                                    }
                                    className="absolute -top-2 -right-2 w-7 h-7 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-lg"
                                  >
                                    <FiMinus />
                                  </button>
                                  <div className="grid grid-cols-2 gap-4">
                                    <InputField
                                      type="selectWithAdd"
                                      label="Component"
                                      value={item.componentId}
                                      onChange={(selected) => {
                                        const updated = [
                                          ...sampleSpectroInputs,
                                        ];
                                        updated[index].componentId =
                                          selected?.value;
                                        setSampleSpectroInputs(updated);
                                      }}
                                      options={isSpectroData}
                                      onAddNewClick={() =>
                                        setModalType("sampleSpectroComponent")
                                      }
                                      placeholder="Select Component"
                                    />
                                    <InputField
                                      label="Value"
                                      type="text"
                                      value={item.percentage}
                                      onChange={(val) => {
                                        const updated = [
                                          ...sampleSpectroInputs,
                                        ];
                                        updated[index].percentage = val;
                                        setSampleSpectroInputs(updated);
                                      }}
                                      unit="%"
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>

                            <button
                              type="button"
                              onClick={handleAddSampleSpectro}
                              className="w-full mt-6 py-4 bg-violet-50 text-violet-600 rounded-2xl text-xs font-black uppercase tracking-widest hover:bg-violet-600 hover:text-white transition-all duration-300"
                            >
                              + Add Sample Component
                            </button>
                          </div>

                          <div className="bg-white p-6 rounded-[2rem] border border-slate-100 shadow-xl shadow-slate-200/50">
                            <div className="flex items-center gap-3 mb-6">
                              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary border border-primary/20 uppercase text-[10px] font-black tracking-widest">
                                <FaClipboardList />
                              </div>
                              <h4 className="text-sm font-black text-slate-800 uppercase tracking-widest">
                                Final Spectro Report Component (%)
                              </h4>
                            </div>

                            <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
                              {finalSpectroInputs.map((item, index) => (
                                <div
                                  key={index}
                                  className="group p-4 bg-slate-50 border border-slate-100 rounded-2xl relative hover:bg-white hover:shadow-lg transition-all"
                                >
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleRemoveFinalSpectro(index)
                                    }
                                    className="absolute -top-2 -right-2 w-7 h-7 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-lg"
                                  >
                                    <FiMinus />
                                  </button>
                                  <div className="grid grid-cols-2 gap-4">
                                    <InputField
                                      type="selectWithAdd"
                                      label="Component"
                                      value={item.componentId}
                                      onChange={(selected) => {
                                        const updated = [...finalSpectroInputs];
                                        updated[index].componentId =
                                          selected?.value;
                                        setFinalSpectroInputs(updated);
                                      }}
                                      options={isSpectroData}
                                      onAddNewClick={() =>
                                        setModalType("finalSpectroComponent")
                                      }
                                      placeholder="Select Component"
                                    />
                                    <InputField
                                      label="Value"
                                      type="text"
                                      value={item.percentage}
                                      onChange={(val) => {
                                        const updated = [...finalSpectroInputs];
                                        updated[index].percentage = val;
                                        setFinalSpectroInputs(updated);
                                      }}
                                      unit="%"
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>

                            <button
                              type="button"
                              onClick={handleAddFinalSpectro}
                              className="w-full mt-6 py-4 bg-primary/10 text-primary rounded-2xl text-xs font-black uppercase tracking-widest hover:bg-primary hover:text-white transition-all duration-300"
                            >
                              + Add Final Component
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </form>

              <div className="px-8 py-4 bg-white border-t border-slate-100 flex flex-col lg:flex-row items-center gap-6 shadow-[0_-10px_30px_rgba(0,0,0,0.03)]">
                <div className="flex-1 w-full lg:max-w-xl relative group">
                  <div className="absolute left-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-lg bg-slate-50 flex items-center justify-center text-slate-400 group-focus-within:bg-primary/10 group-focus-within:text-primary transition-all">
                    <FiFileText size={16} />
                  </div>
                  <input
                    type="textarea"
                    placeholder="Add production remarks or notes here..."
                    className="w-full h-12 bg-slate-50 border border-slate-100 rounded-xl pl-14 pr-4 text-xs font-semibold focus:bg-white focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none"
                    value={foundryEntry.REMARK}
                    onChange={(e) =>
                      setFoundryEntry((prev) => ({
                        ...prev,
                        REMARK: e.target.value,
                      }))
                    }
                  />
                </div>

                <div className="flex items-center gap-4">
                  <Button
                    text="Discard"
                    className="flex-1 sm:flex-none bg-white hover:bg-slate-50 text-slate-600 border border-slate-300 px-4 py-2 rounded-lg font-bold transition-all flex items-center justify-center gap-2"
                    icon={IoMdClose}
                    onClick={onCancel}
                  />
                  <Button
                    text="Save Draft"
                    className="bg-orange hover:bg-slate-50 text-black font-bold px-4 py-2 rounded-lg shadow-sm border border-slate-200 transition-all text-sm gap-2"
                    icon={BsSave2Fill}
                    onClick={handleSubmit}
                  />

                  <Button
                    text="  Finalize Log"
                    className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-4 py-2 rounded-lg shadow-lg shadow-blue-200 transition-all flex items-center gap-2"
                    icon={FaPaperPlane}
                    onClick={handleSubmit}
                  />
                </div>
              </div>
            </div>
          </div>

          <style>{`
            .custom-scrollbar::-webkit-scrollbar {
              width: 5px;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
              background: transparent;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
              background: #e2e8f0;
              border-radius: 10px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
              background: #cbd5e1;
            }
          `}</style>

          <Model
            isOpen={!!modalType}
            onClose={() => setModalType(false)}
            name={`Add ${modalType}`}
          >
            <EntityAddModal
              type={modalType}
              onClose={(newOption) => {
                setModalType(null);
                handleEntityAddSuccess(modalType, newOption);
              }}
            />
          </Model>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default FoundryForm;
